import "firebase/compat/firestore"
import "firebase/compat/auth"
import "firebase/compat/storage"
import { firestore as db } from "src/Firebase"
import { toDecimal } from "src/utils/toDecimal"
import { setTracked, trackContifico } from "src/services/contifico"

const getActiveDocs = snapshot =>
  snapshot.docs.filter(doc => doc.data()?.Activa !== false)

const notifyActiveSnapshot = (observer, snapshot) => {
  const filtered = { ...snapshot, docs: getActiveDocs(snapshot) }
  if (typeof observer === "function") {
    observer(filtered)
    return
  }
  observer?.next?.(filtered)
}

export const getImagen = Banco => db.collection("banco").doc(Banco)

export const newAccountBank = (Conjunto, AccountBank, Imagen) =>
  db.collection("conjuntos").doc(Conjunto).collection("cuentas").add({
    NombreCuenta: AccountBank.NombreCuenta,
    NumeroCuenta: AccountBank.NumeroCuenta,
    TipoIdentificacion: AccountBank.TipoIdentificacion,
    TipoCuenta: AccountBank.TipoCuenta,
    Identificacion: AccountBank.Identificacion,
    Correo: AccountBank.Correo,
    Banco: AccountBank.Banco,
    SaldoInicial: AccountBank.SaldoInicial,
    FechaCorte: AccountBank.FechaCorte,
    Logo: Imagen,
    TipoMetodo: "Cuenta Bancaria",
    Activa: true,
  })

export const getCuentabyConjunto = (observer, Conjunto) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("cuentas")
    .where("TipoMetodo", "==", "Cuenta Bancaria")
    .onSnapshot(
      snapshot => notifyActiveSnapshot(observer, snapshot),
      error => observer?.error?.(error)
    )

export const getCajasbyConjunto = (observer, Conjunto) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("cuentas")
    .where("TipoMetodo", "==", "Caja")
    .onSnapshot(
      snapshot => notifyActiveSnapshot(observer, snapshot),
      error => observer?.error?.(error)
    )

export const getAllBanks = observer =>
  db.collection("banco").onSnapshot(observer)

export const updateCuenta = (Conjunto, AccountBank, documentoId) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("cuentas")
    .doc(documentoId)
    .update({
      NombreCuenta: AccountBank.NombreCuenta,
      NumeroCuenta: AccountBank.NumeroCuenta,
      TipoIdentificacion: AccountBank.TipoIdentificacion,
      TipoCuenta: AccountBank.TipoCuenta,
      Identificacion: AccountBank.Identificacion,
      Correo: AccountBank.Correo,
      Banco: AccountBank.Banco,
    })

export const updateCuentaStatus = (conjuntoId, cuentaId, activa) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("cuentas")
    .doc(cuentaId)
    .update({
      Activa: activa,
    })

export const deleteCuentabyID = (Conjunto, cuentaId) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("cuentas")
    .doc(cuentaId)
    .delete()

export const updateTranferencia = (
  Conjunto,
  documentoId,
  tranferenciaId,
  cantidad
) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("cuentas")
    .doc(documentoId)
    .collection("transferencias")
    .doc(tranferenciaId)
    .update({
      estado: "Aprobado",
      cantidadRecibida: cantidad,
    })

export const getDetallesPago = (Usuario, Detalles) =>
  db
    .collection("usuarios")
    .doc(Usuario)
    .collection("valoresPendientes")
    .doc(Detalles)

export const deleteValoresPendientes = (Usuario, ValorPendiente) =>
  db
    .collection("usuarios")
    .doc(Usuario)
    .collection("valoresPendientes")
    .doc(ValorPendiente)
    .delete()

export const newHistorial = (Usuario, Cuenta, Transferencia) =>
  db.collection("usuarios").doc(Usuario).collection("HistorialPagos").add({
    Usuario,
    Cuenta,
    Tranferencia: Transferencia,
    FechaConfirmacion: new Date(),
  })

export const getUserByConjunto = (observer, conjuntoID) =>
  db
    .collection("usuarios")
    .where("ConjuntoUid", "==", conjuntoID)
    .onSnapshot(observer)

export const getConjunto = conjuntoID =>
  db.collection("conjuntos").doc(conjuntoID).get()
export const newSaldo = (conjuntoID, data) =>
  setTracked(
    db.collection("conjuntos").doc(conjuntoID).collection("ingresos").doc(),
    data,
    "ingreso",
    conjuntoID
  )
export const newIngreso = (conjuntoID, data) =>
  setTracked(
    db.collection("conjuntos").doc(conjuntoID).collection("ingresos").doc(),
    {
      Valor: data.Valor,
      Descripcion: data.Descripcion,
      Fecha: data.Fecha || new Date(),
      Forma: data.Forma,
      CuentaUid: data.CuentaDestino,
      Cobros: data.Valores,
      Usuario: "Transferencia de fondos",
      Comprobante: data.Comprobante,
      Conciliado: false,
      ComprobanteTransaccion: data.ComprobanteTransaccion,
    },
    "ingreso",
    conjuntoID
  )
export const newEgreso = (conjuntoID, data) =>
  setTracked(
    db.collection("conjuntos").doc(conjuntoID).collection("egresos").doc(),
    {
      Valor: data.Valor,
      Descripcion: data.Descripcion,
      Fecha: data.Fecha || new Date(),
      CuentaUid: data.CuentaOrigen,
      Pagos: data.ValoresEgr,
      Forma: data.Forma,
      Proveedor: data.Proveedor,
      Comprobante: data.Comprobante,
      Nombre: "Transferencia de fondos",
      Conciliado: false,
      Factura: data.Factura,
      NumeroComprobanteEgreso: data.NumeroComprobanteEgreso,
      createEgreso: data.Fecha || new Date(),
    },
    "egreso",
    conjuntoID
  )

export const getIngresos = (observer, conjuntoUid, cuentaUid) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("ingresos")
    .where("CuentaUid", "==", cuentaUid)
    .onSnapshot(observer)

export const getEgresos = (observer, conjuntoUid, cuentaUid) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("egresos")
    .where("CuentaUid", "==", cuentaUid)
    .onSnapshot(observer)

export const getConjuntoComprobante = (observer, Conjunto) =>
  db.collection("conjuntos").doc(Conjunto).onSnapshot(observer)

export const updateComprobante = (conjuntoUid, data) =>
  db.collection("conjuntos").doc(conjuntoUid).update({
    NumeroComprobante: data.Ingreso,
    NumeroComprobanteEgreso: data.Egreso,
  })

export const anularSaldoI = async (idConjunto, ingreso) => {
  const data = ingreso
  const batch = db.batch()
  const cobros = data.Cobros
  const updateCobros = []

  cobros.forEach(cobro => {
    updateCobros.push({
      Casa: cobro?.Casa || "",
      Descripcion: cobro?.Descripcion || "",
      Rubro: cobro.Rubro,
      SubRubro: cobro.SubRubro,
      Valor: 0,
    })
  })
  const incomeRef = db
    .collection(`conjuntos/${idConjunto}/ingresos`)
    .doc(ingreso.id)
  batch.update(incomeRef, {
    Cobros: updateCobros,
    Descripcion: "Anulación",
    Conciliado: true,
    Valor: 0,
    Saldo: 0,
    Descuento: 0,
    esAnticipoCuentas: false,
  })

  return batch.commit().then(trackContifico(idConjunto, "ingreso", ingreso.id))
}

export const getSaldoContable = async (conjuntoId, cuentaId, saldoInicial) => {
  try {
    const isSaldoInicialIngreso = data =>
      String(data?.Forma || "")
        .trim()
        .toLowerCase() === "saldo inicial"

    const ahora = new Date()

    const ingresosSnapshot = await db
      .collection("conjuntos")
      .doc(conjuntoId)
      .collection("ingresos")
      .where("CuentaUid", "==", cuentaId)
      .where("Fecha", "<=", ahora)
      .get()

    const totalIngresos = ingresosSnapshot.docs.reduce((sum, doc) => {
      const data = doc.data()
      if (isSaldoInicialIngreso(data)) return sum
      return sum + (parseFloat(data.Valor) || 0)
    }, 0)

    const egresosSnapshot = await db
      .collection("conjuntos")
      .doc(conjuntoId)
      .collection("egresos")
      .where("CuentaUid", "==", cuentaId)
      .where("Fecha", "<=", ahora)
      .get()

    const totalEgresos = egresosSnapshot.docs.reduce(
      (sum, doc) => sum + (parseFloat(doc.data().Valor) || 0),
      0
    )

    return toDecimal(
      parseFloat(saldoInicial || 0) + totalIngresos - totalEgresos
    )
  } catch (error) {
    return parseFloat(saldoInicial || 0)
  }
}
